import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  ThomasCampaign,
  ThomasAdvertiser,
  UserInfo,
  ThomasUserInfo,
  ProductFulfillment,
  ProductFulfillmentVersion
} from 'models/interfaces';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import { ApolloClient } from 'apollo-client';

export const GET_ADVERTISER_DATA_QUERY = gql`
  query GetAdvertiserData($tgrams_id: String!) {
    advertiser: thomasAdvertiserByTgramsId(tgrams_id: $tgrams_id) {
      name
      tgrams_id
    }
    thomasCampaigns: thomasCampaignsByTgramsId(tgrams_id: $tgrams_id) {
      campaign_id
      tgrams_id
      product_id
      name
      start_date
      end_date
      status_id
      created_date
    }
    templates: thomasTemplatesByTgramsId(tgrams_id: $tgrams_id) {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
    }
    productFulfillmentsVersions: productFulfillmentsVersionByTgramsId(tgrams_id: $tgrams_id) {
      opportunity_id
      item_id
      campaign_id
    }
    productFulfillments: productFulfillmentsByTgramsId(tgrams_id: $tgrams_id) {
      opportunity_id
      item_id
      quantity
      product_sku
    }
    userInfo: UserInfo {
      firstName
      lastName
      roles
      claims
    }
  }
`;

export const GET_ADVERTISER_DATA_QUERY_PRODUCT = gql`
  query GetAdvertiserDataProduct($tgrams_id: String!, $product_id: String) {
    advertiser: thomasAdvertiserByTgramsId(tgrams_id: $tgrams_id) {
      name
      tgrams_id
    }
    thomasCampaigns: thomasCampaignsByTgramsIdAndProduct(
      tgrams_id: $tgrams_id
      product_id: $product_id
    ) {
      campaign_id
      tgrams_id
      product_id
      name
      start_date
      end_date
      status_id
      created_date
    }
    templates: thomasTemplatesByTgramsId(tgrams_id: $tgrams_id) {
      p3_configuration_id
      p3_campaign_id
      configuration_status_id
      description
      name
      rank_points
      coverage_areas
      preview_ads
      program_value
      last_updated_date
      last_updated_by
      created_date
      start_date
      end_date
    }
    productFulfillmentsVersions: productFulfillmentsVersionByTgramsId(tgrams_id: $tgrams_id) {
      opportunity_id
      item_id
      campaign_id
    }
    productFulfillments: productFulfillmentsByTgramsId(tgrams_id: $tgrams_id) {
      opportunity_id
      item_id
      quantity
      product_sku
      order_source
    }
    userInfo: UserInfo {
      firstName
      lastName
      roles
      claims
    }
  }
`;

interface ThomasCampaignContainerRenderProps {
  advertiser: ThomasAdvertiser;
  thomasCampaigns: ThomasCampaign[];
  templates: P3Configuration[];
  productFulfillmentsVersions: ProductFulfillmentVersion[];
  productFulfillments: ProductFulfillment[];
  userInfo: ThomasUserInfo;
  client: ApolloClient<any>;
}

interface ThomasCampaignContainerProps {
  tgrams_id: string;
  product_id: string;
  children: (props: ThomasCampaignContainerRenderProps) => any;
}

const ThomasAdvertiserCampaignsContainer: React.FunctionComponent<ThomasCampaignContainerProps> = ({
  tgrams_id,
  product_id,
  children,
  ...props
}) => {
  let query = GET_ADVERTISER_DATA_QUERY_PRODUCT;

  return (
    <Query<ThomasCampaignContainerRenderProps>
      query={query}
      variables={{ tgrams_id, product_id }}
      fetchPolicy={'network-only'}
    >
      {({
        data: {
          advertiser,
          thomasCampaigns,
          templates,
          productFulfillmentsVersions,
          productFulfillments,
          userInfo
        } = {
          advertiser: {} as ThomasAdvertiser,
          thomasCampaigns: [] as ThomasCampaign[],
          templates: [] as P3Configuration[],
          productFulfillmentsVersions: [] as ProductFulfillmentVersion[],
          productFulfillments: [] as ProductFulfillment[],
          userInfo: {} as ThomasUserInfo
        },
        loading,
        client
      }) => {
        if (loading) {
          return null;
        }
        if (!advertiser) {
          advertiser = {} as ThomasAdvertiser;
        }
        return (
          children &&
          children({
            ...props,
            advertiser,
            thomasCampaigns,
            templates,
            productFulfillmentsVersions,
            productFulfillments,
            userInfo,
            client
          })
        );
      }}
    </Query>
  );
};

export default ThomasAdvertiserCampaignsContainer;
